import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import * as moment from 'moment';
import {environment as env} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BusinessRuleCoverageService {

    constructor(private http: HttpClient) {
    }

    public getBusinessRuleCoverage(request: any): Observable<BusinessRuleCoverageModel> {
        return this.http.post<BusinessRuleCoverageModel>(`${env.apiBaseUrl}/dashboard/business_rule_coverage`,
            {
                ...request,
                startDate: moment(request.startDate).format('YYYY-MM-DD'),
                endDate: moment(request.endDate).format('YYYY-MM-DD')
            });
    }
}

export class BusinessRuleCoverageModel {
    coveragePct: number;
    totalJourneys: number;
    coveredJourneys: number;
    uncoveredJourneys: number;
    distinctRules: number;
    byRuleType: RuleTypeCoverageModel[];
    topRules: TopRuleCoverageModel[];
}

export class RuleTypeCoverageModel {
    ruleType: string;
    journeys: number;
    pctOfTotal: number;
}

export class TopRuleCoverageModel {
    ruleName: string;
    ruleType: string;
    journeys: number;
}
